export default "__VITE_ASSET__DBoFWvT7__"